import { Component, EventEmitter, Inject, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from '@core/services/toast.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-reassign-modal',
    templateUrl: './reassign-modal.component.html',
    styleUrls: ['./reassign-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReassignModalComponent implements OnInit {
  reassignForm: FormGroup | any;
  @Output() formData = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public reassignData: any,
    private fb: FormBuilder,
    private toast: ToastService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    this.reassignForm = this.fb.group({
      title: [null, [Validators.required, Validators.maxLength(250)]],
      description: [this.reassignData.description, [Validators.required, Validators.maxLength(250)]],
    });
  }

  onSubmit(): void {
    if (this.reassignForm.invalid) {
      this.toast.error(this.translocoService.translate('configuration.common.requiredFieldsToast'));
      return;
    }
    this.formData.emit(this.reassignForm.value);
  }
}
